"use strict";
var __importDefault = (this && this.__importDefault) || function (mod) {
    return (mod && mod.__esModule) ? mod : { "default": mod };
};
Object.defineProperty(exports, "__esModule", { value: true });
exports.RTRTManager = void 0;
var api_1 = __importDefault(require("./api"));
var templates_service_1 = require("./templates.service");
var upload_service_1 = require("./upload.service");
var RTRTManager = /** @class */ (function () {
    function RTRTManager(url, apiKey) {
        this.api = (0, api_1.default)(url, apiKey);
        this.templateService = new templates_service_1.TemplateService(this.api);
        this.uploadService = new upload_service_1.UploadService(this.api);
    }
    return RTRTManager;
}());
exports.RTRTManager = RTRTManager;
